import { useState, useEffect } from 'react'
import { useMsal } from '@azure/msal-react'
import { loginRequest } from '../utils/authConfig'
import { callMsGraph, callMsGraphForPhoto } from '../api/authApiService'
import { getCurrentUser } from 'aws-amplify/auth'

const useProfileData = () => {
  const { instance } = useMsal()
  const [graphData, setGraphData] = useState(null)
  const [profileImageData, setProfileImageData] = useState(null)
  const [cognitoData, setCognitoData] = useState(null)
  const [accessToken, setAccessToken] = useState(null)
  const loginType = localStorage.getItem('loginType')

  const handleLogout = () => {
    localStorage.removeItem('authenticated')
    localStorage.removeItem('loginType')
    setAccessToken(null)
  }

  const fetchMicrosoftData = async () => {
    try {
      const accounts = instance.getAllAccounts()
      if (accounts.length === 0) {
        handleLogout()
        return
      }

      const firstAccount = accounts[0]
      instance.setActiveAccount(firstAccount)

      const response = await instance.acquireTokenSilent(loginRequest)
      // Store the access token for use with other Graph API calls
      setAccessToken(response.accessToken)

      const [profileDataGraphResponse, profileImageGraphResponse] = await Promise.all([
        callMsGraph(response.accessToken),
        callMsGraphForPhoto(response.accessToken)
      ])

      setGraphData(profileDataGraphResponse)
      setProfileImageData(profileImageGraphResponse)
    } catch (error) {
      console.error('Error acquiring token or fetching Microsoft profile data:', error)
      handleLogout()
    }
  }

  const fetchCognitoData = async () => {
    try {
      const loggedInUser = await getCurrentUser()
      setCognitoData({
        username: loggedInUser.username,
        ...loggedInUser.attributes
      })
    } catch (error) {
      console.error('Error fetching Cognito user:', error)
      handleLogout()
    }
  }

  useEffect(() => {
    if (loginType === 'microsoft' && instance) {
      fetchMicrosoftData()
    }
    if (loginType === 'cognito') {
      fetchCognitoData()
    }
  }, [])

  return {
    graphData,
    profileImageData,
    cognitoData,
    accessToken
  }
}

export default useProfileData